import { useEffect, useRef, useState } from "react";

export default function CountUp({ end = 0, duration = 1600, suffix = "", className = "" }) {
  const [val, setVal] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    if (!ref.current) return;
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting && !started.current) {
          started.current = true;
          const start = performance.now();
          const animate = (now) => {
            const t = Math.min(1, (now - start) / duration);
            const eased = 1 - Math.pow(1 - t, 3);
            setVal(Math.floor(end * eased));
            if (t < 1) requestAnimationFrame(animate);
            else setVal(end);
          };
          requestAnimationFrame(animate);
        }
      });
    }, { threshold: 0.4 });
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, [end, duration]);

  return <span ref={ref} className={className}>{val.toLocaleString()}{suffix}</span>;
}
